module.exports = __webpack_public_path__ + "img/dsci0013.ec36714e.jpg";